import { BaseReader } from "../base-reader";
import { DelegationsRequestArgs, DelegationsSchema } from "./delegations.types";

export class DelegationsReader extends BaseReader {
  /**
   * Get all active delegations for a subaccount
   * @param args The arguments containing the subaccount address
   * @returns The list of active delegations for the given subaccount
   */
  async getAll({ subAddr, fetchOptions }: DelegationsRequestArgs) {
    const response = await this.getRequest({
      schema: DelegationsSchema,
      url: `${this.deps.config.tradingHttpUrl}/api/v1/delegations`,
      queryParams: new URLSearchParams({
        subaccount: subAddr,
      }),
      options: fetchOptions,
    });

    return response.data;
  }
}
